export default (o) => {
    if (o === null || typeof o === 'undefined') {
        return 0;
    }
    if (Array.isArray(o) || typeof o === 'string') {
        return o.length;
    }
    if (typeof o === 'object') {
        return Object.keys(o).length;
    }
    throw new Error(`Don't know how to compute the size of a ${typeof o}`);
};
